import DeliveryFrequencyUtils from 'utils/DeliveryFrequency';
import BasketUtils from 'utils/Basket';

/**
 * Formats the flex incentives saving amount string for display.
 */
export const formatFlexIncentivesDiscount = (product = {}) => {
    return DeliveryFrequencyUtils.formatSavingAmountString(
        {
            discountAmount: product.flexDiscountAmount,
            discountedPrice: product.flexDiscountedPrice,
            discountType: DeliveryFrequencyUtils.REPLENISHMENT_DISCOUNT_TYPES.AMOUNT
        },
        product.qty
    );
};

/**
 * Formats the standard saving amount string for display.
 */
export const formatSavingAmount = (product = {}) => {
    return DeliveryFrequencyUtils.formatSavingAmountString(product, product.qty, false, true, false, product.acceleratedPromotion);
};

/**
 * Returns the formatted saving amount string for a subscription product.
 * Uses flex incentives formatting when the feature is enabled and the product
 * has a flex discounted price; falls back to standard discount formatting otherwise.
 */
export const getSavingAmount = (product = {}, isFlexIncentivesEnabled) => {
    const hasFlexIncentives = isFlexIncentivesEnabled && product.flexDiscountedPrice;

    return hasFlexIncentives ? formatFlexIncentivesDiscount(product) : formatSavingAmount(product);
};

/**
 * Formats the product price as a currency string.
 */
export const formatPrice = (product = {}) => {
    const qty = product.qty ?? 1;

    return DeliveryFrequencyUtils.formatCurrency(parseFloat(BasketUtils.removeCurrency(product.price)), qty);
};
